module.exports = __webpack_public_path__ + "static/media/Alix Cohen.442268b4.png";